const linkLandingPagesDE = {
    "view": {
        "table": {
            "title": "Ihre Link-Landingpages",
            "column": {
                "title": "Titel",
                "description": "Beschreibung",
                "backUrl": "Zurück-Url",
                "created": "Erstellt",
                "landingPage": "Landingpage",
                "action": "Aktion"
            },
            "label": {
                "landingPage": "Landingpage"
            },
            "button": {
                "view": "Ansehen",
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "message": {
                "linkCopied": "Link in die Zwischenablage kopiert!"
            }
        },
        "modal": {
            "edit": {
                "header": "Bearbeiten {{linkLandingPageName}}?",
                "body": "Sind Sie sicher, dass Sie diese Link-Landingpage bearbeiten möchten?"
            },
            "delete": {
                "header": "Löschen {{linkLandingPageName}}?",
                "body": "Sind Sie sicher, dass Sie diese Link-Landingpage löschen möchten?"
            }
        },
        "message": {
            "success": "Link-Landingpage wurde entfernt!",
            "error": "Etwas ist schiefgelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "llpAllowanceSpent": "Sie haben Ihr Link-Landingpage-Kontingent aufgebraucht. Um weitere Link-Landingpages zu erstellen, bitte Ihr Konto upgraden oder unser Support-Team kontaktieren.",
            "subscriptionFeatureUnavailable": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>upgraden</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>erneuern</1> Sie Ihr Abonnement, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    },
    "add": {
        "title": "Link-Landingpage hinzufügen",
        "form": {
            "label": {
                "domain": "Domain",
                "title": "Titel",
                "backUrl": "Zurück-Url",
                "shortDescription": "Kurzbeschreibung",
                "logo": "Logo",
                "backgroundImage": "Hintergrundbild",
                "blurredBackground": "Verschwommener Hintergrund",
                "blurred": "Verschwommen",
                "notBlurred": "Nicht verschwommen",
                "blurStrength": "Unschärfestärke",
                "layout": "Layout",
                "font": "Schriftart",
                "socialIconPlacement": "Platzierung der sozialen Symbole",
                "socialIconColor": "Farbe der sozialen Symbole",
                "buttonCorners": "Ecken des Buttons",
                "buttonStyle": "Button-Stil",
                "colorCustomisation": "Farbgestaltung",
                "premadeColors": "Vorgefertigte Farben",
                "customColors": "Benutzerdefinierte Farben",
                "headerBackground": "Kopfzeilenhintergrund",
                "singleColor": "Einzelfarbe",
                "gradient": "Verlauf",
                "bodyBackground": "Körperhintergrund",
                "titleColor": "Titelfarbe",
                "descriptionColor": "Beschreibungsfarbe",
                "buttonColor": "Buttonfarbe",
                "buttonTextColor": "Button-Textfarbe",
                "backgroundColor": "Hintergrundfarbe"
            },
            "placeholder": {
                "domain": "Domain auswählen",
                "shortDescription": "Ein paar Worte über Ihre Landingpage. Maximal 80 Zeichen"
            },
            "help_text": {
                "domain": "Wählen Sie die Domain aus, für die Sie eine Link-Landingpage erstellen möchten.",
                "logo": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung mindestens 500x500 px",
                "backgroundImage": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung von 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout Eins",
                    "layoutTwo": "Layout Zwei"
                },
                "socialIconPlacement": {
                    "header": "Kopfzeile",
                    "bottomOfTheBody": "Unterseite des Körpers"
                },
                "socialIconColor": {
                    "color": "Farbe",
                    "black": "Schwarz",
                    "white": "Weiß"
                },
                "buttonCorners": {
                    "rounded": "Abgerundet",
                    "semiRounded": "Halb abgerundet",
                    "squared": "Quadratisch"
                },
                "buttonStyle": {
                    "outlined": "Umrandet",
                    "filled": "Gefüllt"
                }
            },
            "button": {
                "submit": "Einreichen"
            },
            "validation": {
                "formInvalid": "Formular kann nicht eingereicht werden! Bitte alle Felder ausfüllen und Fehler überprüfen!",
                "storeUrlRequired": "{{store}} Url ist erforderlich",
                "storeUrlValid": "Bitte eine gültige {{store}} Url hinzufügen."
            }
        },
        "message": {
            "success": "Link-Landingpage wurde hinzugefügt!",
            "error": "Etwas ist schiefgelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "add": {
                "header": "Landingpage hinzufügen {{title}}?",
                "body": "Sind Sie sicher, dass Sie eine Link-Landingpage mit dem Titel {{title}} erstellen möchten?"
            }
        }
    },
    "update": {
        "title": "Link-Landingpage aktualisieren",
        "form": {
            "label": {
                "domain": "Domain",
                "title": "Titel",
                "backUrl": "Zurück-Url",
                "shortDescription": "Kurzbeschreibung",
                "logo": "Logo",
                "backgroundImage": "Hintergrundbild",
                "blurredBackground": "Verschwommener Hintergrund",
                "blurred": "Verschwommen",
                "notBlurred": "Nicht verschwommen",
                "blurStrength": "Unschärfestärke",
                "layout": "Layout",
                "font": "Schriftart",
                "socialIconPlacement": "Platzierung der sozialen Symbole",
                "socialIconColor": "Farbe der sozialen Symbole",
                "buttonCorners": "Ecken des Buttons",
                "buttonStyle": "Button-Stil",
                "colorCustomisation": "Farbgestaltung",
                "premadeColors": "Vorgefertigte Farben",
                "customColors": "Benutzerdefinierte Farben",
                "headerBackground": "Kopfzeilenhintergrund",
                "singleColor": "Einzelfarbe",
                "gradient": "Verlauf",
                "bodyBackground": "Körperhintergrund",
                "titleColor": "Titelfarbe",
                "descriptionColor": "Beschreibungsfarbe",
                "buttonColor": "Buttonfarbe",
                "buttonTextColor": "Button-Textfarbe",
                "backgroundColor": "Hintergrundfarbe"
            },
            "placeholder": {
                "domain": "Domain auswählen",
                "shortDescription": "Ein paar Worte über Ihre Landingpage. Maximal 80 Zeichen"
            },
            "help_text": {
                "domain": "Wählen Sie die Domain aus, für die Sie eine Link-Landingpage erstellen möchten.",
                "logo": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung mindestens 500x500 px",
                "backgroundImage": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung von 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout Eins",
                    "layoutTwo": "Layout Zwei"
                },
                "socialIconPlacement": {
                    "header": "Kopfzeile",
                    "bottomOfTheBody": "Unterseite des Körpers"
                },
                "socialIconColor": {
                    "color": "Farbe",
                    "black": "Schwarz",
                    "white": "Weiß"
                },
                "buttonCorners": {
                    "rounded": "Abgerundet",
                    "semiRounded": "Halb abgerundet",
                    "squared": "Quadratisch"
                },
                "buttonStyle": {
                    "outlined": "Umrandet",
                    "filled": "Gefüllt"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Andere"
                }
            },
            "button": {
                "submit": "Einreichen"
            }
        },
        "message": {
            "success": "Link-Landingpage wurde aktualisiert!",
            "error": "Etwas ist schiefgelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "update": {
                "header": "Landingpage aktualisieren {{title}}?",
                "body": "Sind Sie sicher, dass Sie die Link-Landingpage mit dem Titel {{title}} aktualisieren möchten?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Soziale Links",
        "label": {
            "order": "Reihenfolge",
            "platform": "Plattform",
            "destinationUrl": "Ziel-Url"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Andere"
            }
        },
        "button": {
            "remove": "Entfernen",
            "add": "Weitere hinzufügen"
        }
    },
    "featuredLinksRow": {
        "title": "Hervorgehobene Links",
        "label": {
            "order": "Reihenfolge",
            "label": "Bezeichnung",
            "destinationUrl": "Ziel-Url"
        },
        "button": {
            "remove": "Entfernen",
            "add": "Weitere hinzufügen"
        }
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Analysen für Musiklink abrufen"
        },
        "button": {
            "last7Days": "Letzte 7 Tage",
            "last14Days": "Letzte 14 Tage",
            "last30Days": "Letzte 30 Tage"
        },
        "linkLandingPageViews": {
            "title": "Link-Landingpage-Ansichten",
            "subtitle": "Gesamtansichten",
            "label": {
                "views": "Ansichten"
            }
        },
        "socialLinkClicks": {
            "title": "Klicks auf soziale Links",
            "subtitle": "Gesamtklicks",
            "table": {
                "column": {
                    "platform": "Plattform",
                    "destinationUrl": "Ziel-Url",
                    "clicks": "Klicks",
                    "clicksPct": "Klicks (%)"
                }
            }
        },
        "featuredLinkClicks": {
            "title": "Klicks auf hervorgehobene Links",
            "subtitle": "Gesamtklicks",
            "table": {
                "column": {
                    "label": "Bezeichnung",
                    "destinationUrl": "Ziel-Url",
                    "clicks": "Klicks",
                    "clicksPct": "Klicks (%)"
                }
            }
        },
        "topTerritories": {
            "title": "Top-Territorien",
            "subtitle": "Gesamtansichten",
            "table": {
                "column": {
                    "territory": "Territorium",
                    "views": "Ansichten",
                    "viewsPct": "Ansichten (%)"
                },
                "label": {
                    "otherTerritories": "Andere Territorien"
                }
            }
        },
        "topBrowsers": {
            "title": "Top-Browser",
            "subtitle": "Gesamtansichten",
            "table": {
                "column": {
                    "browser": "Browser",
                    "views": "Ansichten",
                    "viewsPct": "Ansichten (%)"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Top-Gerätetypen",
            "table": {
                "column": {}
            }
        },
        "topOperatingSystems": {
            "title": "Top-Betriebssysteme",
            "label": {
                "os": "Betriebssystem",
                "views": "Ansichten"
            }
        }
    }
};

export default linkLandingPagesDE;